import { IOrderFlexibleColumns, ITableSettings } from '../types/types/table';
import useTable from './useTable';
import { useMemo } from 'react';
import useLocalStorage from './useLocalStorage';
import { Comparator } from '../utils/gridSorting';

function useFlexibleColumnsTable(
  array: any,
  settingsName: string,
  columns: Array<IOrderFlexibleColumns>,
  defaultOrderBy: string,
  defaultOrder: string,
  defaultComparators?: Array<{
    sortingKey: string;
    comparator: Comparator<string>;
  }>,
) {
  const defaultSettings: ITableSettings = {
    orderBy: defaultOrderBy,
    order: defaultOrder === 'asc' ? 'asc' : 'desc',
    ...(defaultComparators ? { sortingComparators: defaultComparators } : {}),
    hidedColumns: columns.filter((f) => f.hided).map((column) => column.id),
    columnsOrderIds: columns
      .filter((f) => !f.hided && !f.isFixed)
      .map((column) => column.id),
  };

  const { settings } = useLocalStorage(settingsName, defaultSettings);

  const {
    order,
    orderBy,
    columnsOrderIds,
    hidedColumns,
    onSort,
    onSortColumns,
    onToggleHideColumn,
    unHideAllColumn,
    sortedArray,
    onRestoreDefault,
  } = useTable({
    initialOrderBy: settings?.orderBy,
    initialOrder: settings?.order,
    initialColumnsOrderIds: settings?.columnsOrderIds,
    initialHidedColumns: settings?.hidedColumns,
    array: array,
    settingsName: settingsName,
    defaultSettings,
  });

  const fixedColumns = columns.filter((f) => f.isFixed).map((item) => item.id);

  const columnsOrder = [...columnsOrderIds, ...fixedColumns];
  const columnsList: Array<IOrderFlexibleColumns> = [];
  columnsOrder
    .filter((id: any) => !hidedColumns.includes(id))
    .map((id: any) =>
      columns.find((f) => {
        if (f.id === id) {
          columnsList.push(f);
        }
      }),
    );

  const columnsListForPopup = useMemo(
    () =>
      columns
        .filter((f) => f.label !== '' && f.canHide)
        .map((column) => ({
          ...column,
          hide: hidedColumns.includes(column.id),
        })),
    [hidedColumns],
  );

  return {
    array,
    order,
    orderBy,
    columnsOrderIds: columnsOrder,
    onSort,
    onSortColumns,
    onToggleHideColumn,
    unHideAllColumn,
    sortedArray,
    onRestoreDefault,
    columnsList,
    columnsListForPopup,
    hidedColumns,
  };
}

export default useFlexibleColumnsTable;
